import format from 'xml-formatter'

export const DefaultOptions = {
  tabWidth: 4,
  useTabs: false
}

export default async function formatXML(input, options) {
  const {tabWidth, useTabs} = {...DefaultOptions, ...options}
  const indent = useTabs ? '\t' : ' '.repeat(tabWidth)

  return format(input, {
    lineSeparator: '\n',
    indentation: indent
  })
}
